/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Err_Workflow_ArchivedInputs */

const en_sch_err_workflow_archived = /** @type {(inputs: Sch_Err_Workflow_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That workflow is archived. Restore it or choose another one.`)
};

const de_sch_err_workflow_archived = /** @type {(inputs: Sch_Err_Workflow_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Workflow ist archiviert. Stelle ihn wieder her oder wähle einen anderen.`)
};

/**
* | output |
* | --- |
* | "That workflow is archived. Restore it or choose another one." |
*
* @param {Sch_Err_Workflow_ArchivedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_err_workflow_archived = /** @type {((inputs?: Sch_Err_Workflow_ArchivedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Err_Workflow_ArchivedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_err_workflow_archived(inputs)
	return en_sch_err_workflow_archived(inputs)
});